/** Normalize GET /companies paginated response (A-04 Universe scale). */
export function unwrapCompaniesPage(data) {
  if (Array.isArray(data)) {
    return { items: data, total: data.length, skip: 0, limit: data.length, hasMore: false };
  }
  const items = data?.items || [];
  const total = data?.total ?? items.length;
  const skip = data?.skip ?? 0;
  const limit = data?.limit ?? items.length;
  return { items, total, skip, limit, hasMore: skip + items.length < total };
}
